import {
    createAsyncThunk,
    createSlice,
} from "@reduxjs/toolkit";

import {
    employeeAdvanceApi,
} from "../../components/dashboard/components/AdminComponent/EmployeeManagement/utils/employeeApi";


const initialState = {

    records:
        [],

    selected:
        null,

    recoveries:
        [],

    summary: {

        totalAdvances:
            0,

        totalAdvanceAmount:
            0,

        totalRecoveredAmount:
            0,

        totalBalanceAmount:
            0,

        activeAdvances:
            0,

        recoveredAdvances:
            0,

        cancelledAdvances:
            0,

    },

    pagination: {

        page:
            1,

        limit:
            10,

        totalRecords:
            0,

        totalPages:
            1,

    },

    loading:
        false,

    actionLoading:
        false,

    error:
        null,

};


export const fetchEmployeeAdvances =
    createAsyncThunk(
        "employeeAdvance/list",

        async (
            payload,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeAdvanceApi
                        .getList(
                            payload
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load employee advances."
                    );

                }


                return {

                    records:
                        response?.data ||
                        [],

                    pagination:
                        response?.pagination ||
                        {},

                };

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load employee advances."
                );

            }

        }
    );


export const fetchEmployeeAdvanceSummary =
    createAsyncThunk(
        "employeeAdvance/summary",

        async (
            params = {},
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeAdvanceApi
                        .getSummary(
                            params
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load advance summary."
                    );

                }


                return response?.data ||
                    {};

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load advance summary."
                );

            }

        }
    );


const employeeAdvanceSlice =
    createSlice({

        name:
            "employeeAdvance",

        initialState,

        reducers: {

            clearAdvanceError:
                (
                    state
                ) => {

                    state.error =
                        null;

                },

        },

        extraReducers:
            (
                builder
            ) => {

                builder

                    .addCase(
                        fetchEmployeeAdvances
                            .pending,
                        (
                            state
                        ) => {

                            state.loading =
                                true;

                            state.error =
                                null;

                        }
                    )

                    .addCase(
                        fetchEmployeeAdvances
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.records =
                                action
                                    .payload
                                    ?.records ||
                                [];

                            state.pagination = {

                                ...state.pagination,

                                ...(
                                    action
                                        .payload
                                        ?.pagination ||
                                    {}
                                ),

                            };

                        }
                    )

                    .addCase(
                        fetchEmployeeAdvances
                            .rejected,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.error =
                                action.payload;

                        }
                    );


                builder
                    .addCase(
                        fetchEmployeeAdvanceSummary
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.summary = {

                                ...state.summary,

                                ...(
                                    action.payload ||
                                    {}
                                ),

                            };

                        }
                    );

            },

    });


export const {
    clearAdvanceError,
} =
    employeeAdvanceSlice.actions;


export default employeeAdvanceSlice.reducer;